export const depositABI = [
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "_usdtToken",
                          "type": "address"
                  }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "target",
                          "type": "address"
                  }
          ],
          "name": "AddressEmptyCode",
          "type": "error"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "account",
                          "type": "address"
                  }
          ],
          "name": "AddressInsufficientBalance",
          "type": "error"
  },
  {
          "inputs": [
                  {
                          "internalType": "uint256",
                          "name": "amount",
                          "type": "uint256"
                  }
          ],
          "name": "deposit",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
  },
  {
          "inputs": [],
          "name": "FailedInnerCall",
          "type": "error"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "token",
                          "type": "address"
                  }
          ],
          "name": "SafeERC20FailedOperation",
          "type": "error"
  },
  {
          "anonymous": false,
          "inputs": [
                  {
                          "indexed": true,
                          "internalType": "address",
                          "name": "user",
                          "type": "address"
                  },
                  {
                          "indexed": false,
                          "internalType": "uint256",
                          "name": "amount",
                          "type": "uint256"
                  }
          ],
          "name": "Deposit",
          "type": "event"
  },
  {
          "anonymous": false,
          "inputs": [
                  {
                          "indexed": false,
                          "internalType": "uint256",
                          "name": "allowance",
                          "type": "uint256"
                  },
                  {
                          "indexed": false,
                          "internalType": "uint256",
                          "name": "amount",
                          "type": "uint256"
                  }
          ],
          "name": "LogAllowance",
          "type": "event"
  },
  {
          "anonymous": false,
          "inputs": [
                  {
                          "indexed": true,
                          "internalType": "address",
                          "name": "previousOwner",
                          "type": "address"
                  },
                  {
                          "indexed": true,
                          "internalType": "address",
                          "name": "newOwner",
                          "type": "address"
                  }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
  },
  {
          "inputs": [],
          "name": "pause",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
  },
  {
          "anonymous": false,
          "inputs": [
                  {
                          "indexed": false,
                          "internalType": "address",
                          "name": "account",
                          "type": "address"
                  }
          ],
          "name": "Paused",
          "type": "event"
  },
  {
          "anonymous": false,
          "inputs": [
                  {
                          "indexed": true,
                          "internalType": "address",
                          "name": "user",
                          "type": "address"
                  },
                  {
                          "indexed": false,
                          "internalType": "uint256",
                          "name": "amount",
                          "type": "uint256"
                  }
          ],
          "name": "Refund",
          "type": "event"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "user",
                          "type": "address"
                  }
          ],
          "name": "refundUser",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "newOwner",
                          "type": "address"
                  }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
  },
  {
          "inputs": [],
          "name": "unpause",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
  },
  {
          "anonymous": false,
          "inputs": [
                  {
                          "indexed": false,
                          "internalType": "address",
                          "name": "account",
                          "type": "address"
                  }
          ],
          "name": "Unpaused",
          "type": "event"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "recipient",
                          "type": "address"
                  },
                  {
                          "internalType": "uint256",
                          "name": "amount",
                          "type": "uint256"
                  }
          ],
          "name": "withdraw",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
  },
  {
          "anonymous": false,
          "inputs": [
                  {
                          "indexed": true,
                          "internalType": "address",
                          "name": "user",
                          "type": "address"
                  },
                  {
                          "indexed": false,
                          "internalType": "uint256",
                          "name": "amount",
                          "type": "uint256"
                  }
          ],
          "name": "Withdraw",
          "type": "event"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "user",
                          "type": "address"
                  }
          ],
          "name": "getDeposit",
          "outputs": [
                  {
                          "internalType": "uint256",
                          "name": "",
                          "type": "uint256"
                  }
          ],
          "stateMutability": "view",
          "type": "function"
  },
  {
          "inputs": [],
          "name": "owner",
          "outputs": [
                  {
                          "internalType": "address",
                          "name": "",
                          "type": "address"
                  }
          ],
          "stateMutability": "view",
          "type": "function"
  },
  {
          "inputs": [],
          "name": "paused",
          "outputs": [
                  {
                          "internalType": "bool",
                          "name": "",
                          "type": "bool"
                  }
          ],
          "stateMutability": "view",
          "type": "function"
  },
  {
          "inputs": [],
          "name": "usdtToken",
          "outputs": [
                  {
                          "internalType": "contract IERC20",
                          "name": "",
                          "type": "address"
                  }
          ],
          "stateMutability": "view",
          "type": "function"
  },
  {
          "inputs": [
                  {
                          "internalType": "address",
                          "name": "",
                          "type": "address"
                  }
          ],
          "name": "userDeposits",
          "outputs": [
                  {
                          "internalType": "uint256",
                          "name": "",
                          "type": "uint256"
                  }
          ],
          "stateMutability": "view",
          "type": "function"
  }
];